window.addEventListener('SITE_START', () => {
  // 파일 업로드
  const fileBoxes = document.querySelectorAll('.input-box--file');
  if (!fileBoxes.length) return;

  fileBoxes.forEach(box => {
    const inputFile = box.querySelector('.input-upload');
    const inputText = box.querySelector('.input-text');

    inputFile?.addEventListener('change', () => {
      if (!inputFile.files?.length) {
        inputText.value = '';
        inputText.placeholder = '선택된 파일이 없습니다.';
        return;
      }

      const fileNames = Array.from(inputFile.files)
        .map(f => f.name)
        .join(', ');

      inputText.value = fileNames;
    });
  });

  // textarea 최대글자
  const textarea = document.querySelector('.input-box .textarea');
  const counter = document.querySelector('.input-box .textarea__counter');

  if (!textarea || !counter) return;

  const max = textarea.getAttribute('maxlength') || 2000;

  const updateCount = () => {
    const length = textarea.value.length;
    counter.textContent = `${length}/${max}`;
  };

  textarea.addEventListener('input', updateCount);
  updateCount();

  // 이메일
  const $emailGroups = document.querySelectorAll('.email-domain-group');
  if (!$emailGroups.length) return;

  $emailGroups.forEach($emailGroup => {
    const $dropdown = $emailGroup.querySelector('.email-domain');
    const $value = $dropdown.querySelector('.dropdown__value');
    const $options = $dropdown.querySelectorAll('.dropdown__option');
    const $input = $emailGroup.querySelector('.email-direct');

    if (!$dropdown || !$value || !$input) return;

    // 드롭다운에서 옵션 클릭 시 input 처리
    $options.forEach($option => {
      $option.addEventListener('click', (e) => {
        const val = $option.getAttribute('data-value');
        const text = $option.textContent.trim();

        // 직접입력 선택 → input 초기화 & 활성화
        if (val === 'custom') {
          $input.value = '';
          $input.removeAttribute('readonly');
          $input.focus();
        } else {
          // 도메인 선택 → 값 채우고 readonly 처리
          $input.value = text;
          $input.setAttribute('readonly', 'readonly');
        }
      });
    });
  });
});
